module.exports = __webpack_public_path__ + "static/media/dingMusic.639ede5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/dingMusic.mp3
// module id = U/Jh
// module chunks = 5